export default function () {
  return {
    company: null,
    companies: [],
    companiesLoading: false,
    companiesLoaded: false,
    lastCompanyId: null
  }
}
